import { Vue, Component, Prop } from 'vue-property-decorator'
import DataForResult from '~/types/DataForResult'
import s from '~/utils/s'

@Component
export default class ResultBlock extends Vue {
  @Prop({ required: true, type: Object })
  readonly item!: DataForResult

  async addToBasket (event: MouseEvent) {
    event.stopPropagation()
    const regionId = s(this.$store).regions.regionId
    const sectionId = s(this.$store).regions.sectionId
    await this.$store.$api.catalogResultAddToCart(this.item.productIds, regionId, sectionId)
    await s(this.$store).basket.fillData()
    await s(this.$store).general.showPopup('ResultToCartPopup')
  }

  renderButtonMakeOrder () {
    return (
      <div class="basket-result__submit-wrapper">
        <div class="button-text"
          onClick={this.addToBasket}
          disabled={this.item.productIds.length > 0}>
              Добавить в корзину
        </div>
      </div>
    )
  }

  render () {
    return (
      <div class="basket-result result-block">
        <div class="basket-result__prices">
          <div class="basket-result__prices-name">
            Товары ({ this.item.total })
          </div>
          <div class="basket-result__prices-value">
            { this.item.totalSum } ₽
          </div>
        </div>
        <div class="basket-result__prices">
          <div class="basket-result__prices-name">
            Скидка
          </div>
          <div class="basket-result__prices-value basket-result__prices-value_discount">
            { this.item.discount } ₽
          </div>
        </div>
        <div class="basket-result__prices basket-result__prices_summ">
          <div class="basket-result__prices-name">
            Стоимость набора:
          </div>
          <div class="basket-result__prices-value basket-result__prices-value_summ">
            { this.item.totalDiscountPrice } ₽
          </div>
        </div>
        {this.renderButtonMakeOrder()}
      </div>
    )
  }
}
